// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__W3uPN","header":"Header_header__v0n67"};